/**
 * Mock option/variant data for product items.
 * TODO: Remove when backend supports variants/options - this is placeholder data
 * used to demonstrate the expandable row functionality in ProductsTable.
 */

export interface MockOptionItem {
  id: string
  name: string
  imageUrl?: string
  colorName?: string
}

export const MOCK_OPTIONS: Record<string, MockOptionItem[]> = {
  default: [],
}
